






















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { TableColumn, TableBody } from '@/constants/components/table';

@Component({})
export default class Table extends Vue {
  // テーブルに表示するカラム配列
  @Prop({ default: [] })
  private columns!: Array<TableColumn>;
  // テーブルに表示するデータ配列
  @Prop({ default: [] })
  private body!: Array<TableBody>;
  // 表示アイテム数
  @Prop({ default: 100 })
  private perPage?: number;
  // チェックボックス項目の表示制御
  @Prop({ default: false })
  private showSelect?: boolean;
  @Prop({ default: '' })
  private itemKey?: string;
  // 選択されているチェックボックス
  private selected = [];
  // テーブル内項目のchip制御
  @Prop({ default: () => [] })
  private chipItems?: Array<{ [k: string]: string }>;
  @Prop({ default: () => [] })
  private buttonItems?: Array<{ [k: string]: string }>;
  // テーブル内項目のボタンラベル名
  @Prop({ default: '' })
  private buttonLabel?: string;

  @Prop()
  private customFilter?: Function;

  @Prop()
  private customSort?: Function;
  // ヘッダー固定
  @Prop({ default: false })
  private fixedHeader?: boolean;
  // テーブルの高さ
  @Prop({ default: 'auto' })
  private height?: string;

  @Watch('indexedItems')
  private clearSelected() {
    this.selected.splice(0);
  }

  /**
   * 親コンポーネントに押下した行を通知する
   * @module clickRowOpratipon
   * @param  {TableBody} - 対象行データ
   * @return {TableBody} - 押下された行データ
   */
  @Emit('clickRowOpratipon')
  public clickRowOpratipon(clickRecord: TableBody): TableBody {
    return clickRecord;
  }
  /**
   * 親コンポーネントにチェックボックスをチェック、アンチェックした行を通知する
   * valueにはチェックした場合true, アンチェックした場合はfalseが与えられる
   * itemは定義されているテーブル項目によって可変となる
   * @module itemSelected
   * @param {item: any, value: boolean}
   * @return {item: any, value: boolean}
   */
  @Emit('itemSelected')
  public itemSelected(value: { item: any; value: boolean }) {
    return value;
  }
  /**
   * 親コンポーネントに選択されているアイテムを配列で返します
   * @module enterSelect
   * @param Array<{[k: string]: string }>
   * @return Array<{[k: string]: string }>
   */
  @Emit('enterSelect')
  private enterSelect(dataList: Array<{[k: string]: string }>) {
    return dataList;
  }
  /**
   * 親コンポーネントに押下した行を通知する
   * @module clickButton
   * @param  {TableBody} - 対象行データ
   * @return {TableBody} - 押下された行データ
   */
  @Emit('clickButton')
  public clickButton(item: TableBody): TableBody {
    return item;
  }
  // v-slotの動的な生成に使用
  private addHeader(value: string) {
    return `item.` + value;
  }

  get indexedItems() {
    return this.body.map((item, index) => ({
        id: index,
        ...item
      }))
  }
}
